import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import UserProfileForm from './UserProfile';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { IUser } from 'constants/user.constants';
import { convertKeysToSnakeCase } from '../../utils/global.util';
import { updateUserProfile } from 'state/reducers/auth.reducers';
import { Dialog, DialogContent } from '@mui/material';
import styled from '@emotion/styled';

interface IProfileModalProps {
  openProfileModal: boolean;
  setOpenProfileModal: Dispatch<SetStateAction<boolean>>;
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 100%;
    max-width: 900px;
  }
`;

const UserProfileModal: React.FC<IProfileModalProps> = ({ openProfileModal, setOpenProfileModal }) => {
  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const dispatch = useAppDispatch();
  const [onEdit, setOnEdit] = useState(false);

  const onUpdateUser = (data: Partial<IUser>) => {
    const convertedToSnakeCaseData = convertKeysToSnakeCase(data);
    dispatch(updateUserProfile(convertedToSnakeCaseData));
    setOnEdit(false);
  };

  const handleClose = () => {
    setOpenProfileModal(false);
    setOnEdit(false);
  };

  return (
    <StyledDialog data-testid={'profile-modal'} open={openProfileModal} onClose={handleClose}>
      <DialogContent>
        <UserProfileForm {...userDetails} disabled={onEdit} setOnEdit={setOnEdit} onUpdateUser={onUpdateUser} />
      </DialogContent>
    </StyledDialog>
  );
};

export default UserProfileModal;
